import { setupProductSamplesPage } from './ProductSamples';
import { setupAddressPage } from './Address';
import { logAssetsError } from './common/logging';
import { initConfirmation } from './Confirmation';

window.o_global.eventLoader.onLoad(10, () => {
    const sampleSelectionForm = document.forms.namedItem('sample_form');
    const sampleSelectButton: HTMLButtonElement | null = document.querySelector('.or_js_button-samples-selected');

    const isConfirmationPage = document.querySelector('.or_sample-confirmation') !== null;

    if (isConfirmationPage) {
        const continueShoppingButton = document.getElementById('continueShoppingButton') as HTMLButtonElement;
        const toBasketButton = document.getElementById('toBasketButton') as HTMLButtonElement;
        initConfirmation(toBasketButton, continueShoppingButton);
    } else if (sampleSelectionForm && sampleSelectButton) {
        setupProductSamplesPage(sampleSelectionForm, sampleSelectButton);
    } else {
        const variationsInput = document.getElementById('or_js_selected-variations');
        const backButton = document.getElementById('or_js_address-esi-back-button');
        const formDiv = document.getElementById('or_js_sample-address-form');
        const errorBanner = document.getElementById('or_js_banner-technical-error');
        if (variationsInput && formDiv && errorBanner) {
            setupAddressPage({ variationsInput, backButton, formDiv, errorBanner });
        } else {
            logAssetsError('Invalid Order Sample HTML!');
        }
    }
});
